// @flow
import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAuthentication } from "../../account/actions/userActions";
import type { StateType, DispatchType } from "../../global/types/redux";

export const hasPrincipal = (principal: string, userPrincipals: Array<string>): boolean => {
  if (principal !== "user") {
    if (userPrincipals !== undefined) {
      for (let i = 0; i < userPrincipals.length; i++) {
        if (principal === userPrincipals[i]) {
          return true;
        }
      }
    }
    return false;
  } else {
    // at this stage we should have already checked whether the user is authenticated
    return true;
  }
};

const hasOneOfPrincipalList = (principals: Array<string>, userPrincipals: Array<string>): boolean => {
  for (let i = 0; i < principals.length; i++) {
    if (hasPrincipal(principals[i], userPrincipals)) {
      return true;
    }
  }
  return false;
};

const hasAllOfPrincipalList = (principals: Array<string>, userPrincipals: Array<string>): boolean => {
  for (let i = 0; i < principals.length; i++) {
    if (!hasPrincipal(principals[i], userPrincipals)) {
      return false;
    }
  }
  return true;
};

type AuthenticationsType = {
  auth: boolean,
  principal: boolean,
  oneOfPrincipalList: boolean,
  allOfPrincipalList: boolean
};

const isAuthenticated = (auths: AuthenticationsType): boolean => {
  if (auths.auth && auths.principal && auths.oneOfPrincipalList && auths.allOfPrincipalList) {
    return true;
  } else {
    return false;
  }
};

type AuthPropsType = {
  user: Object,
  auth: boolean,
  principal: string,
  oneOfPrincipalList: Array<string>,
  allOfPrincipalList: Array<string>,
  children: React$Element<*>,
  unAuthChildren?: React$Element<*>,
  actions: { fetchAuthentication: Function }
};

class UserAuth extends Component<AuthPropsType, *> {

  authentications: AuthenticationsType = {
    auth: false,
    principal: true,
    oneOfPrincipalList: true,
    allOfPrincipalList: true,
  };

  componentDidMount() {
    const user = this.props.user; //redux user
    if (user && !user.fetchingAuth && user.auth === null) {
      this.props.actions.fetchAuthentication();
    }
  }

  render(): * {
    const user = this.props.user; //redux user
    const authentications = this.authentications;
    if (user && user.auth !== null) {
      if (user.auth === true) {
        authentications.auth = true;
        if (this.props.principal) {
          authentications.principal = hasPrincipal(this.props.principal, user.groups);
        }
        if (this.props.oneOfPrincipalList) {
          authentications.oneOfPrincipalList = hasOneOfPrincipalList(this.props.oneOfPrincipalList, user.groups);
        }
        if (this.props.allOfPrincipalList) {
          authentications.allOfPrincipalList = hasAllOfPrincipalList(this.props.allOfPrincipalList, user.groups);
        }
      } else {
        return this.props.unAuthChildren ? this.props.unAuthChildren : null;
      }
    }
    else {
      return null;
    }

    if (isAuthenticated(authentications)) {
      return this.props.children;
    } else {
      if (user.groups !== undefined) {
        return this.props.unAuthChildren ? this.props.unAuthChildren : null;
      }
      else {
        return null;
      }
    }
  };
}

const mapStateToProps = (state: StateType): * => ({
  user: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchAuthentication }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAuth);

